import React from 'react';

export default function Resource() {
    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-6xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
                    {/* Left - Image */}
                    <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 md:p-8 flex items-center justify-center h-full">
                        <div className="relative w-full max-w-md">
                            <img
                                src="https://sagepath.vercel.app/assets/images/backgrounds/sagapath-home-image.png"
                                alt="Resource"
                                className="rounded-xl shadow-lg w-full object-cover"
                            />
                            <img
                                src="https://sagepath.vercel.app/assets/images/landing/saga-path-title.png"
                                alt="Resource"
                                className="absolute bottom-4 left-1/2 w-4/5 -translate-x-1/2 rounded-lg object-cover"
                            />
                        </div>
                    </div>

                    {/* Right - About SagePath */}
                    <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 md:p-10 h-full">
                        <p className="inline-flex items-center rounded-full bg-blue-50 text-blue-700 text-sm font-semibold px-4 py-1 mb-4">
                            Smart Learning Guidance
                        </p>
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
                            SagePath Application
                        </h1>
                        <p className="text-gray-600 text-base md:text-lg mb-6 leading-relaxed">
                            Sage Path is a cutting-edge educational application designed to guide students in making informed decisions about their academic pursuits. By leveraging user input, Sage Path provides personalized course recommendations tailored to individual interests, skills, and goals. This innovative tool empowers students to navigate the vast array of educational options, ensuring they embark on a fulfilling and successful academic journey.
                        </p>

                        <div className="space-y-6 mb-8">
                            <div>
                                <h2 className="text-lg font-semibold text-gray-900 mb-3">Key Features</h2>
                                <ul className="space-y-2 text-gray-700">
                                    <li className="flex items-start gap-3">
                                        <span className="text-blue-600 font-bold">•</span>
                                        <span>Personalized course recommendations based on skills, goals, and interests.</span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <span className="text-blue-600 font-bold">•</span>
                                        <span>Progress tracking dashboard to monitor learning milestones and growth.</span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <span className="text-blue-600 font-bold">•</span>
                                        <span>Resource discovery for curated study paths, tutorials, and support materials.</span>
                                    </li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="text-lg font-semibold text-gray-900 mb-3">Why Students Use SagePath</h2>
                                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-gray-700">
                                    <li className="bg-gray-50 rounded-lg px-4 py-3">Clear academic direction</li>
                                    <li className="bg-gray-50 rounded-lg px-4 py-3">Reduced decision fatigue</li>
                                    <li className="bg-gray-50 rounded-lg px-4 py-3">Better course alignment</li>
                                    <li className="bg-gray-50 rounded-lg px-4 py-3">Higher learning confidence</li>
                                </ul>
                            </div>
                        </div>


                        <a
                            href="https://sagepath.vercel.app/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition duration-300 shadow-md"
                        >
                            Visit SagePath
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}